import "#legacy/admin/page_builder/tool.js";
/**
 * Load lifecycle:
 *  tool.setState - used by tools with more complicated state requirements. Most tools just pass the component context to their templates, so that's the default
 *  tool.render - by default updates the tool element with markup generated by tool template, overrid for react apps
 *  tool.bind - bind events to the tool or component here
 *  tool.unbind - unbind any events
 *
 * Update lifecycle
 *  tool.setState
 *  tool.update
 *  tool.rendered (if the component was rendered)
 *
 * General Notes
 *  - render/bind/unbind are only called on load, after that it's setcontext and update. update is
 *  - identical to render by default, but you can override it. the update lifecycle is only triggered if
 *  - another tool changes the splinter, so if your tool changes a context value, you update your view there.
 */

(function (Event) {
  "use strict";

  Sparkle.PageBuilder.Tool({
    /**
     * @description Unique identifier for the tool component.
     */
    name: "image-editor",
    templateId: "image-editor-template",

    update: function (element, context) {},

    prepareRenderContext: function (context) {
      if (context && context.variants) {
        jQuery.each(context.variants, function () {
          if (this.width && this.height) {
            context.cropped = true;
          }
        });
      }

      return context;
    },

    bind: function (component) {
      var me = this,
        $rootElement = jQuery(this.element),
        $previewElement = $rootElement.find(".preview");

      $rootElement.on("dragenter", ".preview", function (event) {
        event.preventDefault();
        jQuery(this).addClass("drag-over");
      });

      $rootElement.on("dragleave", ".preview", function (event) {
        jQuery(this).removeClass("drag-over");
      });

      $rootElement.on("dragend", ".preview", function (event) {
        jQuery(this).removeClass("drag-end");
      });

      $rootElement.on(
        "drop",
        ".preview",
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          var newFile = event.originalEvent.dataTransfer.files[0];

          Sparkle.PageBuilder.uploadAsset(newFile).done(
            function (data) {
              var asset = component.context;
              asset.url = data.asset.url;
              asset.hi_res_url = data.asset.hi_res_url;
              asset.id = data.asset.id;
              component.save(asset);
              component.render();
              this.render();
            }.bind(this),
          );
        }.bind(this),
      );

      $rootElement.on(
        "click",
        ".preview",
        function () {
          var initialValue = component.context;
          var attributeConfig = this.component.config.attributes[this.component.name] || {};
          var dialog = new Sparkle.PageBuilder.ImageDialog(
            initialValue,
            function (value) {
              component.save(value);

              // we need to reload the tool now to ensure the ui is re-rendered properly.
              // the loader will handle this when we call this tool 'outdated'.
              Event.trigger("pb:tool:outdated", me);

              // Update the image details shown in the sidebar
              Event.trigger("pb:tool:image:updated", component);

              component.render();
            }.bind(this),
            {
              placeholders: attributeConfig.placeholder,
              variants: attributeConfig.variants,
              cropperItems: attributeConfig.cropper_items,
              advanced_options: this.config.advanced_options,
            },
          );
        }.bind(this),
      );
    },

    unbind: function (element) {
      var $element = jQuery(this.element);

      $element.off("dragover");
      $element.off("dragout");
      $element.off("dragend");
      $element.off("drop");
      $element.off("click");
    },
  });
})(Sparkle.PageBuilder.Helpers.Event);
